import styled from '@emotion/styled';
import { Tag, Text, tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { formatDate } from '../utils/formatDate';

const DateTag = styled(Tag)`
  height: 36px;
  position: absolute;
  right: 16px;
  top: -18px;
  text-transform: uppercase;
  color: ${tokens.color.white};
  ${tokens.text('body2')}
`;

const ChurnDateTag = styled(DateTag)`
  background: ${tokens.color.neutral_900};
`;

const Wrapper = styled.div`
  flex: 8;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${tokens.spacer.x2} ${tokens.spacer.x2} ${tokens.spacer.x3};
  background: ${tokens.color.white};
  gap: ${tokens.spacer.x2};
  border-radius: ${tokens.radius.l};
  border: 2px solid ${tokens.color.neutral_600};
  ${tokens.elevation(3)}
`;

const Title = styled(Text)`
  text-transform: capitalize;
`;

type Props = {
  title: string;
  date: string;
  testId: string;
  children: JSX.Element;
};

export function NewPlanCard({ title, date, testId, children }: Props): JSX.Element {
  const { t } = useTranslation('voluntary-churn');

  const formattedDate = formatDate(date);

  return (
    <Wrapper>
      <Title as="h3" textType="header5" data-testid={testId}>
        {title}
      </Title>
      {children}
      <ChurnDateTag>{t('churn.deflection-modal.churn-date', { date: formattedDate })}</ChurnDateTag>
    </Wrapper>
  );
}
